// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><%21--%21 Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license %28Commercial License%29 Copyright 2023 Fonticons, Inc. --><path d=\"M160 64H512c17.7 0 32 14.3 32 32V201.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V304v16c0 35.3 28.7 64 64 64h80 0H512c35.3 0 64-28.7 64-64V240 240 96zM464 166.6l80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconic-gallery img {
    max-width: 100%;
    height: auto;
}

.iconic-gallery figure {
    margin: unset;
    position: relative;
    display: inline-block;
}

.iconic-caption {
    position: absolute;
    bottom: 0;
    padding: 0.25rem;
    background-color: rgba(0,0,0,0.8);
    color: white;
    width: 100%;
    font-size: 0.75rem;
    display: none;
}

[data-iconic-captions="1"] .iconic-caption {
    display: block;
}

[data-iconic-layout="flexbox"],
[data-iconic-layout="flexbox_square"],
[data-iconic-layout="single"],
[data-iconic-layout="single_square"] {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
}

[data-iconic-layout="carousel"] img,
[data-iconic-layout="orbit"] img,
[data-iconic-layout="splider_stack"] img,
[data-iconic-layout="flexbox_square"] img,
[data-iconic-layout="single_square"] img {
    object-fit: cover;
    object-position: center;
    overflow: hidden;
}

[data-iconic-layout="justified"] {
    position: relative;
    overflow: hidden;
}
[data-iconic-layout="justified"]::after {
    content: "";
    display: block;
    clear: both;
}
[data-iconic-layout="justified"] a {
    float: left;
    top: 0;
    left: 0;
}
[data-iconic-layout="justified"] .a>img {
    display: block;
    width: 100%;
    height: auto;
}

.baguetteBox-button {
    background-color: rgba(50,50,50,.8);
}

.iconic-repository::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 1rem;
    height: 1rem;
    display: block;
    margin: 0.5rem auto 0 auto;
}

.iconic-repository[data-iconic-repository="0"] {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/iconic.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;;;;IAKI,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,WAAW;IACX,MAAM;IACN,OAAO;AACX;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gDAAy2B;IACz2B,WAAW;IACX,YAAY;IACZ,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".iconic-gallery img {\n    max-width: 100%;\n    height: auto;\n}\n\n.iconic-gallery figure {\n    margin: unset;\n    position: relative;\n    display: inline-block;\n}\n\n.iconic-caption {\n    position: absolute;\n    bottom: 0;\n    padding: 0.25rem;\n    background-color: rgba(0,0,0,0.8);\n    color: white;\n    width: 100%;\n    font-size: 0.75rem;\n    display: none;\n}\n\n[data-iconic-captions=\"1\"] .iconic-caption {\n    display: block;\n}\n\n[data-iconic-layout=\"flexbox\"],\n[data-iconic-layout=\"flexbox_square\"],\n[data-iconic-layout=\"single\"],\n[data-iconic-layout=\"single_square\"] {\n    display: flex;\n    justify-content: center;\n    flex-flow: row wrap;\n}\n\n[data-iconic-layout=\"carousel\"] img,\n[data-iconic-layout=\"orbit\"] img,\n[data-iconic-layout=\"splider_stack\"] img,\n[data-iconic-layout=\"flexbox_square\"] img,\n[data-iconic-layout=\"single_square\"] img {\n    object-fit: cover;\n    object-position: center;\n    overflow: hidden;\n}\n\n[data-iconic-layout=\"justified\"] {\n    position: relative;\n    overflow: hidden;\n}\n[data-iconic-layout=\"justified\"]::after {\n    content: \"\";\n    display: block;\n    clear: both;\n}\n[data-iconic-layout=\"justified\"] a {\n    float: left;\n    top: 0;\n    left: 0;\n}\n[data-iconic-layout=\"justified\"] .a>img {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n\n.baguetteBox-button {\n    background-color: rgba(50,50,50,.8);\n}\n\n.iconic-repository::after {\n    content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d=\"M160 64H512c17.7 0 32 14.3 32 32V201.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V304v16c0 35.3 28.7 64 64 64h80 0H512c35.3 0 64-28.7 64-64V240 240 96zM464 166.6l80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z\"/></svg>');\n    width: 1rem;\n    height: 1rem;\n    display: block;\n    margin: 0.5rem auto 0 auto;\n}\n\n.iconic-repository[data-iconic-repository=\"0\"] {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
